import React from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import {
    BACHELOR_MASTER_API_FAILED,
    BACHELOR_MASTER_API_IN_PROGRESS,
    EXAM_STATUS_API_FAILED,
    EXAM_STATUS_API_IN_PROGRESS,
    SPECIALIZATION_API_FAILED,
    SPECIALIZATION_API_IN_PROGRESS,
} from "../../../../containers/RegistrationLoginPage/types";
import {useForm} from "react-final-form";
import SubmitButton from "../SubmitButton";
interface Props {
    heading?: string;
}
const SignUpButton: React.FC<Props> = ({heading}: Props) => {
    const form = useForm();
    const formState = form.getState();
    const bachelorsMasterAPIStatus = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.bachelorsMasterAPIStatus,
    );
    const specializationAPIStatus = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.specializationAPIStatus,
    );
    const examStatusAPIStatus = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.examStatusAPIState,
    );
    const isBachelorMasterAPINotCompleted =
        bachelorsMasterAPIStatus === BACHELOR_MASTER_API_IN_PROGRESS ||
        bachelorsMasterAPIStatus === BACHELOR_MASTER_API_FAILED;
    const isSpecializationAPINotCompleted =
        specializationAPIStatus === SPECIALIZATION_API_IN_PROGRESS ||
        specializationAPIStatus === SPECIALIZATION_API_FAILED;
    const isexamStatusAPINotCompleted =
        examStatusAPIStatus === EXAM_STATUS_API_IN_PROGRESS ||
        examStatusAPIStatus === EXAM_STATUS_API_FAILED;
    const isDisabled =
        isBachelorMasterAPINotCompleted ||
        isSpecializationAPINotCompleted ||
        isexamStatusAPINotCompleted ||
        formState.submitSucceeded;

    const isSubmitting = formState.submitting;
    return (
        <SubmitButton
            heading={heading ?? "Register Now"}
            isDisabled={isDisabled}
            isSubmitting={isSubmitting}
            submittingHeading={"Submitting"}
        />
    );
};

export default SignUpButton;
